module.exports = __webpack_public_path__ + "static/media/umbrella-loader-navy-blue.fce97723.gif";